import { updateItems } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  '新片上线': 'bg-primary-50 text-primary-600',
  '功能更新': 'bg-accent-50 text-accent-600',
  '专题上线': 'bg-secondary-100 text-secondary-700',
  '片库扩充': 'bg-primary-50 text-primary-600',
  '系统优化': 'bg-accent-50 text-accent-600',
  '内容合作': 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-xl mx-auto">
          91免费平台内容更新、功能迭代与最新资讯
        </p>

        <div className="relative pl-8 border-l-2 border-background-200">
          {updateItems.map((item, i) => (
            <div key={i} className={`relative pb-10 ${i === updateItems.length - 1 ? 'pb-0' : ''}`}>
              <div className="absolute -left-[29px] top-0 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-100"></div>
              <div className="bg-background-50 rounded-lg p-5">
                <div className="flex flex-wrap items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <span className={`text-xs font-medium px-2 py-0.5 rounded ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}